export const ContactSupport = "If this continues, please contact support@hyperspheretech.com."
